import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import Utils from "../../common/manipurCommon/Utils";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Select from "react-select";
import { Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Button } from "react-bootstrap";
import Swal from "sweetalert2";

const GradeType = () => {

    const [gradeTypeList, setGradeTypeList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [gradeTypeName, setGradeTypeName] = useState("");
    const [gradeTypeId, setGradeTypeId] = useState("");
    const [gradeTypeValue, setGradeTypeValue] = useState("");
    const [gradeTypeDescription, setGradeTypeDescription] = useState("");
    const [gradeTypeStatus, setGradeTypeStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        fetchGradeType();
    }, [])

        async function fetchGradeType() {
            setIsLoading(true);
            const gradeTypResponse = await func.gradelist(null);
            setGradeTypeList(Array.isArray(gradeTypResponse) ? gradeTypResponse : [])
            setIsLoading(false);
        }

    const filteredData = gradeTypeList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const gradeTypNameRender = (rowData) => {
        return <span>{rowData.gradeType} </span>;
    };

    const gradeTypDescRender = (rowData) => {
        return <span>{rowData.gradeTypeDescription} </span>;
    };

    const gradeTypeStatusRender = (rowData) => {
        return <span>{(rowData.gradeTypeStatus == 1) ? "Active" : "Inactive"
        }</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editGradeType(rowData)}>
                <i className="feather-edit" > </i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const gradeId = rowData.gradeTypeId;
        return (
            <Link to="#" onClick={() => deleteGradeType(gradeId)}>
                <i className="feather-trash" > </i>Delete
            </Link>
        );
    };

    async function newGradeType() {
        setIsEdit(false)
        setOpenModal(true)
        setGradeTypeName("");
        setGradeTypeDescription("");
        setGradeTypeValue("");
    }

    async function editGradeType(rowData) {
        const gradeId = rowData.gradeTypeId;
        setIsEdit(true)
        setOpenModal(true)
        const getDetails = await func.gradelist(gradeId);
        setGradeTypeId(getDetails.gradeTypeId);
        setGradeTypeName(getDetails.gradeType);
        setGradeTypeValue(getDetails.gradeTypeValue);
        setGradeTypeDescription(getDetails.gradeTypeDescription);
        setGradeTypeStatus(getDetails.gradeTypeStatus);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateGradeType();
            } else {
                if (gradeTypeName && gradeTypeDescription && gradeTypeValue) {
                    const formData = new FormData();
                    formData.append("gradeType", gradeTypeName);
                    formData.append("gradeTypeDescription", gradeTypeDescription);
                    formData.append("gradeTypeValue", gradeTypeValue);

                    const createGradeTyp = api.GradeType;
                    fetch(createGradeTyp, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.error == false) {
                                Swal.fire({
                                    title: 'Created',
                                    text: result.message,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        // window.location.reload(); // 🔁 Reload only after OK is clicked
                                        setOpenModal(false);
                                        fetchGradeType();
                                    }
                                });
                            } else {
                                if (result.code == 401) {
                                    Utils.logoutUser();
                                }
                                Swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                })
                            }
                        })
                }
            }
        }
    }

    function updateGradeType() {
        const formData = new FormData();
        formData.append("gradeType", gradeTypeName);
        formData.append("gradeTypeValue", gradeTypeValue);
        formData.append("gradeTypeDescription", gradeTypeDescription);
        formData.append("status", gradeTypeStatus);

        const updateGradeTyp = api.GradeType + '/' + gradeTypeId;
        fetch(updateGradeTyp, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setIsEdit(false);
                            setOpenModal(false);
                            fetchGradeType();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function deleteGradeType(gradeId: string) {
        const deleteGradeTyp = api.GradeType + '/' + gradeId + '/' + 0;
        fetch(deleteGradeTyp, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchGradeType();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader" >
                    <div className="loader-img" >
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row" >
                    <div className="sortby-section" >
                        <div className="sorting-info" >
                            <div className="row align-items-center" >
                                <div className="col d-flex justify-content-between" >
                                    <h4>Grade Type </h4>
                                    {
                                        currentPermissions.includes("add") ?
                                            <Link
                                                to="#"
                                                className="btn"
                                                onClick={() => { newGradeType() }}
                                                data-bs-toggle="tooltip"
                                                style={{ fontSize: "24px", padding: "0px" }}
                                                title="Create Grade Type" >
                                                <i className="feather-plus" />&nbsp;
                                            </Link>
                                            : null
                                    }
                                </div>
                            </div>
                            < div className="row col-lg-12 mb-10" >
                                <div className="col-lg-12 text-end dataTables_filter" >
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            < div className="tab-content" >
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble" >
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            > </Column>
                                            < Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="gradeType"
                                                header="Grade Type"
                                                body={gradeTypNameRender}
                                                className="table-inset-btn"
                                            > </Column>
                                            < Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="gradeTypeDescription"
                                                header="Grade Type Description"
                                                body={gradeTypDescRender}
                                                className="table-inset-btn"
                                            > </Column>
                                            < Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="gradeTypeStatus"
                                                header="Grade Type Status"
                                                body={gradeTypeStatusRender}
                                                className="table-inset-btn"
                                            > </Column>
                                            {
                                                currentPermissions.includes("edit") ?
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    > </Column>
                                                    : null
                                            }
                                            {
                                                currentPermissions.includes("delete") ?
                                                    <Column
                                                        className="text-link"
                                                        body={deleteDetails}
                                                    > </Column>
                                                    : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >

            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="md"
                        centered >
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case" > {isEdit ? "Edit " : "Add "} Grade Type </h4>
                            </ModalTitle>
                            < Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)
                                }
                            > </Button>
                        </ModalHeader>
                        < ModalBody >
                            <form ref={formRef}>
                                <div className="col-lg-12 mb-10" >
                                    <div className="input-space" >
                                        <label className="form-label" > Grade Type </label>
                                        < input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="gradeTypName"
                                            value={gradeTypeName}
                                            onChange={(e) => setGradeTypeName(e.target.value)}
                                            placeholder="Grade Type Name" />
                                    </div>
                                </div>
                                < div className="col-lg-12 mb-10" >
                                    <div className="input-space" >
                                        <label className="form-label" > Grade Type Description </label>
                                        < input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="gradeTypDesc"
                                            value={gradeTypeDescription}
                                            onChange={(e) => setGradeTypeDescription(e.target.value)}
                                            placeholder="Grade type Description" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10" >
                                    <div className="input-space" >
                                        <label className="form-label" > Grade Type Value</label>
                                        < input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="gradeTypValue"
                                            value={gradeTypeValue}
                                            onChange={(e) => setGradeTypeValue(e.target.value)}
                                            placeholder="Grade Type Value" />
                                    </div>
                                </div>
                                {
                                    isEdit ?
                                        <>
                                            <div className="row" >
                                                <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }
                                                }>
                                                    <label className="form-label" > Status </label>
                                                </div>
                                                < div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                    <div className="form-check form-switch d-flex align-items-center justify-content-end" >
                                                        <input
                                                            className="form-check-input text-end"
                                                            type="checkbox"
                                                            checked={gradeTypeStatus === '1'}
                                                            id="status"
                                                            onChange={(e) => {
                                                                setGradeTypeStatus(e.target.checked ? '1' : '0')
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </> : null
                                }
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" /> Save </b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal>
                )
            }
        </>
    );
};

export default GradeType;